import axios from 'axios';
import router from '../router';
import domain from '../assets/js/domain.js'
import {
	eventBus
} from '@/components/login/eventBus'; // 引入事件总线
// axios.defaults.baseURL = '/api';
axios.defaults.baseURL = domain.testUrl;
// axios.defaults.baseURL = 'http://192.168.12.213:8089/'; //请求接口的域名 测试

console.log(domain)

//http request 拦截器
axios.interceptors.request.use(
	config => {
		let token = localStorage.getItem('userToken');
		//每个http header都加上token
		config.headers = {
			'Authorization': token,
			'SecurityCode': window.channel,
			'ChannelId': window.channelId,
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		}

		return config
	},
	err => {
		return Promise.reject(err)
	}
)

axios.interceptors.response.use(
	response => {
		return response
	},
	err => {
		console.log(err.response)
		if (err.response.status == 401) { //登录失效
			localStorage.removeItem("userToken");
			localStorage.removeItem("userName");
			// 发布事件以显示登录对话框
			eventBus.$emit('show-login-dialog');
			
		} else if (err.response.status == 404) {
			eventBus.$emit('hide-dialog');
			router.push({
				path: "/notFound"
			})
		} else {
			eventBus.$emit('hide-dialog');
			
			router.push({
				path: "/serverError"
			})
		}
	}
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}, headers = {}) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params: params,
				headers: headers
			})
			.then(response => {
				resolve(response.data);
			})
	})
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data) {
	return new Promise((resolve, reject) => {
		axios.post(url, data)
			.then(response => {
				resolve(response);
			}, err => {
				reject(err)
			})
	})
}